import React from 'react';
import { Icon } from 'components';
import { BoardEmptyMessage, LoadErrorState, MediumButton } from './styles';

interface ILaborReviewLoadErrorProps {
  message: string;
  onBackToTipCalculator: () => void;
}

// Shown instead of the board when something it needs to show or save shifts correctly didn't load.
export const LaborReviewLoadError: React.FC<ILaborReviewLoadErrorProps> = ({ message, onBackToTipCalculator }) => (
  <LoadErrorState data-cy="labor-review-load-error">
    <Icon icon="Error" />
    <BoardEmptyMessage>{message}</BoardEmptyMessage>
    <MediumButton appearance="white" size="small" label="Back to Tip Calculator" onClick={onBackToTipCalculator} data-cy="back-to-tip-calculator-button" />
  </LoadErrorState>
);
